import React from 'react';
import { Paper, Title } from '@mantine/core';

type Props = {
    title: string;
    children: React.ReactNode;
};

export function SectionCard({ title, children }: Props) {
    return (
        <Paper p="lg" withBorder radius="md" mb="lg">
            <Title order={4} fw={600} mb="md">
                {title}
            </Title>
            {children}
        </Paper>
    );
}
